export default __webpack_public_path__ + "static/banxa-dcd2aa4da21a4418dd853c5f5d737513.jpg";